import { render, staticRenderFns } from "./BsCheckbox.vue?vue&type=template&id=ca14c080&scoped=true&lang=html&"
import script from "./BsCheckbox.vue?vue&type=script&lang=js&"
export * from "./BsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BsCheckbox.vue?vue&type=style&index=0&id=ca14c080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca14c080",
  null
  
)

export default component.exports